export const updloadImageState = {
  VALID: 'VALID',
  FILE_SIZE_EXCEED: 'FILE_SIZE_EXCEED',
  INVALID_TYPE: 'INVALID_TYPE',
  REMOVED: 'removed',
};

export const audiences = {
  ORGANIZATION: 'organization',
  AUDIT: 'audit',
  ALLBILLER: 'all-billers',
  DELIVERY: 'delivery',
  EMAS: 'emas',
};

export const submitModalState = {
  NOT_STARTED: 'NOT_STARTED',
  INITIALIZED: 'INITIALIZED',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  ROLLBACK: 'ROLLBACK',
};

export const userPermissions = {
  CREATE_ACQUISITION: 'Acquisition:create',
  DELETE_ACQUISITION: 'Acquisition:delete',
  READ_ACQUISITION: 'Acquisition:read',
  UPDATE_ACQUISITION: 'Acquisition:update',
  READ_AUDIT_LOG: 'Audit Log:read',
  CREATE_COMPANY: 'Company:create',
  DELETE_COMPANY: 'Company:delete',
  READ_COMPANY: 'Company:read',
  UPDATE_COMPANY: 'Company:update',
  CREATE_EMPLOYEE: 'Employee:create',
  DELETE_EMPLOYEE: 'Employee:delete',
  READ_EMPLOYEE: 'Employee:read',
  UPDATE_EMPLOYEE: 'Employee:update',
  READ_HISTORY: 'History:read',
  CREATE_ROLE: 'Role:create',
  DELETE_ROLE: 'Role:delete',
  READ_ROLE: 'Role:read',
  UPDATE_ROLE: 'Role:update',
  CREATE_SETTLEMENT: 'Settlement:create',
};

export const regexPattern = {
  PHONE: /^(\+62|62|08)[0-9]{9,13}$/,
  NUMBER: /^[0-9]+$/,
};

const PAGE_SIZE_TABLE_DEFAULT = 10;
const PAGE_NUM_TABLE_DEFAULT = 1;

export const paginationParam = {
  page_num: PAGE_NUM_TABLE_DEFAULT,
  page_size: PAGE_SIZE_TABLE_DEFAULT,
  page_count: 1,
};

export const FILTER_TYPE = {
  TEXT: 'TEXT',
  DATE_PICKER: 'DATE_PICKER',
  RANGE_PICKER: 'RANGE_PICKER',
  RANGE_INPUT: 'RANGE_INPUT',
  RADIO: 'RADIO',
  BOOL: 'BOOL',
};
